import React, { useCallback } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { safeHTML } from '../../../utils/safeHTML';
import { useModal } from '../../../hooks/useModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { useTranslation } from '../../../translations';

const SavePostcardModal = React.forwardRef(function SavePostcardModal({ title, text, button }, ref) {
  const { closeModal, id } = useModal();
  const { t } = useTranslation();

  const close = useCallback(() => {
    closeModal(id);
  }, [id]);

  return (
    <CustomModal>
      <div className={'save-postcard-modal'} ref={ref}>
        <div className={'save-postcard-modal__content'}>
          <h2 className={'save-postcard-modal__title'}>{safeHTML(t(title))}</h2>
          <p className={'save-postcard-modal__text'}>{safeHTML(t(text))}</p>
          <CustomButton {...button.attr} onClick={close} />
        </div>
      </div>
    </CustomModal>
  );
});
export default SavePostcardModal;
SavePostcardModal.propTypes = {};
